import maxScores from '../../constants/max-scores';

const reverseScore = (score, maxValue) => {
    const min = 1;
    const mid = ((maxValue - min) / 2) + 1;

    return ((mid - score) + mid);
};

/**
 * convert values to number
 */
const formatScores = (values) => {
    const numbers = {};

    Object.keys(values).forEach((key) => {
        numbers[key] = Number(values[key]);
    });

    return numbers;
};

const mapScores = (scores = {}) => {
    const values = {
        Achievement: scores.Achievement,
        Independence: scores.Independence,
        Recognition: scores.RecognitionVal,
        Relationships: scores.Relationships,
        Support: scores.Support,
        'Working Conditions': scores['Working Conditions'],
    };
    const interests = {
        Realistic: scores.Realistic,
        Investigative: scores.Investigative,
        Artistic: scores.Artistic,
        Social: scores.Social,
        Enterprising: scores.Enterprising,
        Conventional: scores.Conventional,
    };
    const workplace = {
        Excellence: scores.Excellence,
        'Guiding Principles': scores['Guiding Principles'],
        Collaboration: scores.Collaboration,
        Innovation: scores.Innovation,
        Recognition: scores.Recognition,
        Performance: scores.Performance,
        Stability: scores.Stability,
    };

    const personality = {
        'Openness to Experience': scores['Intellect / Imagination'],
        Conscientiousness: scores.Conscientiousness,
        Extraversion: scores.Extraversion,
        Agreeableness: scores.Agreeableness,
        // this score is reversed, so we reverse it back
        'Emotional Stability': scores['Emotional Stability'] ?
            reverseScore(scores['Emotional Stability'], maxScores.personality) : null,
    };

    const purpose = {
        'Seeking Purpose': scores['Seeking Purpose'],
        'Presence of Purpose': scores['Presence of Purpose'],
        'Living a Purpose': scores['Living a Purpose'],
    };
    if (scores['Honesty/Humility'] != null) {
        personality['Honesty/Humility'] = scores['Honesty/Humility'];
    }

    return {
        values: typeof scores.Achievement !== 'undefined' ? formatScores(values) : {},
        interests: typeof scores.Realistic !== 'undefined' ? formatScores(interests) : {},
        workplace: typeof scores.Excellence !== 'undefined' ? formatScores(workplace) : {},
        personality: typeof scores.Conscientiousness !== 'undefined' ? formatScores(personality) : {},
        purpose: typeof scores['Seeking Purpose'] !== 'undefined' ? formatScores(purpose) : {},
    };
};

module.exports = mapScores;



// WEBPACK FOOTER //
// ./src/client/utils/map-scores.js